import { Button, Grid, Typography } from "@mui/material";
import GKModal from "components/GKModal";

function ConfirmDeleteModal(props) {
  const {
    open,
    setOpen,
    title,
    onDelete,
    isDelete = false,
    deleteMessage,
    messageContent,
    customButtonText = "",
  } = props;

  const deleteMessageHandler = () => {
    if (deleteMessage) return deleteMessage;
    return `Are you sure you want to delete this item? All of your
    data will be permanently removed. This action cannot be
    undone.`;
  };

  const modalMessageHandler = () => {
    if (isDelete) return deleteMessageHandler();
    if (messageContent) return messageContent;
    return `Are you sure you want to ${title.toLowerCase()} this item?`;
  };

  const buttonTextHandle = () => {
    if (isDelete) return "Delete";
    if (customButtonText) return customButtonText;
    return "Undo";
  };

  // const defaultOptions = {
  //   loop: true,
  //   autoplay: true,
  //   animationData: AnimationData,
  //   rendererSettings: {
  //     preserveAspectRatio: "xMidYMid slice",
  //   },
  // };

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle={isDelete ? `Delete ${title}` : `${title}`}
      footer={
        <Button
          variant="outlined"
          color="error"
          onClick={() => {
            onDelete();
            setOpen(false);
          }}
          sx={{
            fontSize: "0.7rem",
            fontFamily: '"Arial", sans-serif',
            textTransform: "none",
          }}
        >
          {buttonTextHandle()}
        </Button>
      }
    >
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        spacing={2}
      >
        <Grid
          item
          xs={12}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {/* <Lottie options={defaultOptions} height={100} width={100} /> */}
        </Grid>
        <Grid item xs={7} textAlign={"center"}>
          <Typography fontWeight={500} fontSize={15}>
            {modalMessageHandler()}
          </Typography>
        </Grid>
      </Grid>
    </GKModal>
  );
}
export default ConfirmDeleteModal;
